module.exports = __webpack_public_path__ + "img/welcome_11.15c860b1.jpg";